import React from "react";
import { Link } from "react-router-dom";
import { BsLinkedin, BsGithub, BsYoutube, BsInstagram, BsFacebook } from "react-icons/bs";
import newsletter from "../images/newsletter.png";
const Footer = () => {
  return (
    <>
      <footer className="py-4">
        <div className="container-xxl">
          <div className="row align-items-center">
            <div className="col-12 col-md-5 mb-3 mb-md-0">
              <div className="footer-top-data d-flex gap-30 align-items-center">
                <img src={newsletter} alt="newsletter" />
                <h2 className="mb-0 text-white">Sign Up for Newsletter</h2>
              </div>
            </div>
            <div className="col-12 col-md-7">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control py-1"
                  placeholder="Your Email Address"
                  aria-label="Your Email Address"
                  aria-describedby="basic-addon2"
                />
                <span className="input-group-text p-2" id="basic-addon2">
                  Subscribe
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <footer className="py-4">
        <div className="container-xxl">
          <div className="row">
            <div className="col-12 col-md-4 mb-4 mb-md-0">
              <h4 className="text-white mb-4">Contact Us</h4>
              <div>
                <address className="text-white fs-6">
                  Shop No 28, 1st Floor, M D Arcade, <br />{" "}
                  6th Main, HMT Main Rd, Mathikere, <br />
                  Bengaluru, Karnataka 560054
                </address>
                <a
                  href="tel:+918660891557"
                  className="mt-3 d-block mb-1 text-white"
                >
                  +91 8660891557
                </a>
                <a
                  href="tel:+919880572323"
                  className="mt-1 d-block mb-1 text-white"
                >
                  +91 9880572323
                </a>
                <a
                  href="mailto:softechmathikere@gmail.com"
                  className="mt-2 d-block mb-0 text-white"
                >
                  softechmathikere@gmail.com
                </a>
                <div className="social_icons d-flex align-items-center gap-30 mt-4">
                  <a className="text-white" href="https://www.facebook.com/people/Softech/100088274944542/">
                    <BsFacebook className="fs-4" />
                  </a>

                </div>
              </div>
            </div>
            <div className="col-6 col-md-3 mb-4 mb-md-0">
              <h4 className="text-white mb-4">Information</h4>
              <div className="footer-link d-flex flex-column">
                <Link to="/privacy-policy" className="text-white py-2 mb-1">
                  Privacy Policy
                </Link>
                <Link to="/refund-policy" className="text-white py-2 mb-1">
                  Refund Policy
                </Link>
                <Link to="/shipping-policy" className="text-white py-2 mb-1">
                  Shipping Policy
                </Link>
                <Link to="/term-conditions" className="text-white py-2 mb-1">
                  Terms & Conditions
                </Link>
              </div>
            </div>
            <div className="col-6 col-md-3 mb-4 mb-md-0">
              <h4 className="text-white mb-4">Account</h4>
              <div className="footer-link d-flex flex-column">
                <Link to="/about" className="text-white py-2 mb-1">About Us</Link>
                <Link to="/contact" className="text-white py-2 mb-1">Contact</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <footer className="py-4">
        <div className="container-xxl">
          <div className="row">
            <div className="col-12">
              <p className="text-center mb-0 text-white">
                &copy; {new Date().getFullYear()}; Copyright© Intuidtal Techno Private Limited
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
